import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46310c48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "block-wrapper"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = {
  key: 1,
  class: "block-wrapper__link"
}
const _hoisted_4 = { class: "link-row" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "link-row" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "request-link-wrap" }
const _hoisted_10 = { class: "spacer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isLogin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$localize('login.have.account')), 1),
        _createVNode(_component_router_link, {
          class: "link",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('login.have.account.button')), 1)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$localize('login.no.account')) + " ", 1),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/registration/step-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('login.no.account.button')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$localize('login.forgot.password')) + " ", 1),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/password-reset"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('login.forgot.password.button')), 1),
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$localize('login.forgot.password.or')), 1),
          _createVNode(_component_router_link, {
            to: "/login-by-link",
            class: "request-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('login.send.login.link')), 1)
            ]),
            _: 1
          })
        ])
      ]))
}